import React from "react";
import { Award, Shield, TrendingUp, Factory, Package, Handshake } from "lucide-react";
import { Card, CardContent } from "./ui/card";

export default function MengapaShaktiSection() {
  const whyChooseUs = [
    {
      icon: Award,
      title: "Rasa Konsisten",
      description: "Produk bumbu dan rempah dengan fokus pada kualitas dan konsistensi rasa.",
    },
    {
      icon: Shield,
      title: "Proses Produksi Higienis",
      description: "Area produksi tertata dan prosedur kerja mendukung kebersihan dan keamanan.",
    },
    {
      icon: Package,
      title: "Pilihan Kemasan Lengkap",
      description: "Mendukung kebutuhan sachet, standing pouch, hingga bulk (sesuai varian).",
    },
    {
      icon: TrendingUp,
      title: "Pemasaran Nasional",
      description: "Siap mendukung kebutuhan pasar dan mitra di seluruh Indonesia.",
    },
    {
      icon: Factory,
      title: "Siap untuk Kebutuhan Usaha",
      description: "Cocok untuk retail, grosir, distributor, hingga kebutuhan usaha/industri (sesuai kesepakatan).",
    },
    {
      icon: Handshake,
      title: "Komunikasi Responsif",
      description: "Tim siap membantu permintaan katalog, info kemasan, dan diskusi kerja sama.",
    },
  ];

  return (
    <section id="mengapa" className="why-section">
      <div className="section-container">
        <div className="section-header">
          <span className="section-label">Mengapa SHAKTI</span>
          <h2 className="section-title">
            Mengapa Memilih <span className="text-accent">Produk Kami?</span>
          </h2>
          <p className="section-description">
            Alasan utama mitra memilih produk SHAKTI untuk kebutuhan bumbu dan rempah.
          </p>
        </div>

        <div className="why-grid">
          {whyChooseUs.map((item, index) => (
            <Card key={index} className="why-card">
              <CardContent className="why-content">
                <div className="why-icon-wrapper">
                  <item.icon className="why-icon" />
                </div>
                <h3 className="why-title">{item.title}</h3>
                <p className="why-description">{item.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
